import axios from "axios";
import { API_BASE_URL, AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from "configs/AppConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";
import { getCookie, removeCookie } from "../utils/cookieHandler";

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
});

// Config
const TOKEN_PAYLOAD_KEY = "authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = getCookie(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  },
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error?.response?.status === 401) {
      removeCookie(AUTH_TOKEN);
      // Don't hard-redirect if already on auth page — React Router handles it via ProtectedRoute
      if (!window.location.pathname.startsWith(AUTH_PREFIX_PATH)) {
        const currentPath = `${window.location.pathname}${window.location.search}`;
        const redirectParam = currentPath && currentPath !== "/" ? `?${REDIRECT_URL_KEY}=${encodeURIComponent(currentPath)}` : "";
        window.location.href = `${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}${redirectParam}`;
      }
    }
    // Don't redirect on API 404 — let each component handle "not found" gracefully.
    // A missing resource (product, wishlist, etc.) is not the same as a missing page.
    return Promise.reject(error);
  },
);

export default service;
